<app-mu-section-title icon="fa fa-fw fa-list-ul"></app-mu-section-title>
<app-massive-request-table
  [flags]="flags"
  [tableListColumns]="requestTableColumns"
  [filters]="requestFilters"
  [dataList]="requestDataList"
  [tableOptionList]="tableOptionList"
  [actions]="requestActions"
  [statuses]="statuses"
>
</app-massive-request-table>
